module.exports = __webpack_public_path__ + "media/images/icons/filled/android-7db856a7c3924267470fd451866cee1c.svg";